import {
  FONT_SIZES,
  FONT_WEIGHTS,
  Text,
  mediaTabletAndUp,
  tabletAndUpLinaria,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';

export function TextBanner({
  headline,
  subline,
  className,
  isSmallFormat,
  centered,
  addMarginBottom,
  constrained,
}: {
  headline?: string;
  subline?: string;
  className?: string;
  isSmallFormat?: boolean;
  centered?: boolean;
  addMarginBottom?: boolean;
  constrained?: boolean;
}) {
  return (
    <RecoHeaderWrapper
      className={className}
      $centered={centered}
      $addMarginBottom={!centered || addMarginBottom}
      data-constrained={constrained}
    >
      {subline && (
        <Subline
          data-testid="recoLaneSubline"
          color="Grey1"
          $isSmallFormat={isSmallFormat}
        >
          {subline}
        </Subline>
      )}
      {headline && (
        <RecoHeadline
          data-testid="recoLaneHeadline"
          color="Black"
          $isSmallFormat={isSmallFormat}
        >
          {headline}
        </RecoHeadline>
      )}
    </RecoHeaderWrapper>
  );
}

export const RecoHeaderWrapper = styled.div<{
  $centered?: boolean;
  $addMarginBottom?: boolean;
}>`
  display: flex;
  flex-direction: column;

  width: ${props => (props.$centered ? '100%' : 'auto')};
  text-align: ${props => (props.$centered ? 'center' : 'left')};
  margin-bottom: ${({$addMarginBottom}) => ($addMarginBottom ? '1rem' : 0)};

  ${tabletAndUpLinaria(`
    text-align: left;
    margin: 0;
    gap: 8px;
  `)}
`;

export const RecoHeaderWrapperLinaria = styled.div<{
  $centered?: boolean;
  $addMarginBottom?: boolean;
}>`
  display: flex;
  flex-direction: column;

  width: ${({$centered}) => ($centered ? '100%' : 'unset')};
  text-align: ${({$centered}) => ($centered ? 'center' : 'unset')};
  margin-bottom: ${({$addMarginBottom}) =>
    $addMarginBottom ? '1.5rem' : 'unset'};

  ${tabletAndUpLinaria(`
    text-align: left;
    margin: 0;
    gap: 8px;
  `)}
`;

export const RecoHeadline = styled(Text)<{$isSmallFormat?: boolean}>`
  display: inline-block;
  line-height: 1.25;
  font-weight: ${FONT_WEIGHTS.mediumHeavy};
  font-size: ${FONT_SIZES.px16};

  @media ${mediaTabletAndUp} {
    font-size: ${props =>
      props.$isSmallFormat ? FONT_SIZES.px16 : FONT_SIZES.px32};
    font-weight: ${props =>
      props.$isSmallFormat ? FONT_WEIGHTS.mediumHeavy : 800};
    text-align: left;
  }
`;

const Subline = styled(RecoHeadline)<{$isSmallFormat?: boolean}>`
  text-transform: uppercase;
  line-height: 1.6;
  font-weight: ${FONT_WEIGHTS.mediumHeavy};
  font-size: ${FONT_SIZES.px10};

  @media ${mediaTabletAndUp} {
    font-size: ${props =>
      props.$isSmallFormat ? FONT_SIZES.px10 : FONT_SIZES.px12};
    line-height: ${props => (props.$isSmallFormat ? '1.6' : '1.5')};
  }
`;
